/**
 * Age Gate — Manifesto Cervejeiro
 *
 * Verificação de idade 18+ persistida em localStorage com TTL de 30 dias.
 * Chave: `mc_age_verified` — { ts: number (epoch ms) }
 *
 * Comportamento:
 * - DOM ready → checa localStorage → se verificado <30d, não mostra modal
 * - Se não verificado: mostra modal + bloqueia scroll do body
 * - Botão "Sim, tenho 18+": persiste timestamp + fecha
 * - Botão "Não tenho": redireciona para google.com (sai do site)
 *
 * Foco trap: usuário não consegue dar Tab para fora do modal enquanto aberto.
 *
 * Telemetria (FASE 3):
 *   - window.dataLayer.push({ event: 'age_gate_shown', page_path: location.pathname })
 *   - window.dataLayer.push({ event: 'age_gate_verified', page_path: location.pathname })
 *
 * Acessibilidade:
 *   - role="dialog" + aria-modal="true" no container
 *   - foco inicial vai para botão "Sim" automaticamente
 *   - ESC não fecha (intencional — não burlar)
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'mc_age_verified';
  const TTL_DAYS = 30;
  const TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;

  function isVerified() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.ts !== 'number') return false;
      const age = Date.now() - parsed.ts;
      return age >= 0 && age < TTL_MS;
    } catch (err) {
      // localStorage indisponível (modo privado, ad-blocker) — gate aparece sempre
      return false;
    }
  }

  function persistVerified() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ ts: Date.now(), v: 1 })
      );
    } catch (err) {
      // Sem persistência — sessão atual passa, próxima vai pedir de novo
    }
  }

  function trackEvent(name) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: name,
          page_path: window.location.pathname,
        });
      }
      // Defesa em profundidade — também via gtag direto se disponível
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          page_path: window.location.pathname,
        });
      }
    } catch (err) {
      // Silenciar erros de telemetria — não bloqueia funcionalidade
    }
  }

  function showGate(el) {
    el.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Foco inicial no botão "Sim" para acessibilidade
    const yesBtn = document.getElementById('age-gate-yes');
    if (yesBtn) {
      // Pequeno timeout para garantir que o elemento está visível
      setTimeout(() => yesBtn.focus(), 50);
    }

    trackEvent('age_gate_shown');
  }

  function hideGate(el) {
    el.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function setupFocusTrap(el) {
    el.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    const el = document.getElementById('age-gate');
    if (!el) return;

    // Já verificado nos últimos 30d? não mostra
    if (isVerified()) return;

    showGate(el);
    setupFocusTrap(el);

    // Botão "Sim"
    const yesBtn = document.getElementById('age-gate-yes');
    if (yesBtn) {
      yesBtn.addEventListener('click', (e) => {
        e.preventDefault();
        persistVerified();
        hideGate(el);
        trackEvent('age_gate_verified');
      });
    }

    // Botão "Não"
    const noBtn = document.getElementById('age-gate-no');
    if (noBtn) {
      noBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = 'https://www.google.com';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
